import React from 'react';
import Icon from '../icons';
import { URLS } from '../../_config';
import MenuLink from './_components/menuLink';
import { LayoutDashboard } from 'lucide-react';
import noImg from '../../images/no-image.jpg';
import logoFull from '../../images/Cyclops-ops.png';
import logoIcon from '../../images/Cyclops.png';
import { useUserApi } from '../../store/api/hooks/userApiHook';
import toast from 'react-hot-toast';
import { useMenuCollapseSelector } from '../../store/selectors/loaderSelector';
import { useUserSelector } from '../../store/selectors/userSelector';


const LeftPanel: React.FC = () => {

    const uaerAPI: any = useUserApi();
    const collapse = useMenuCollapseSelector();
    const loggedinuser: any = useUserSelector();

    const [show, setShow] = React.useState<boolean>(false);

    const logout = () => {
        uaerAPI.logout({}, (response: any) => {
            console.log('response =>', response);
        }, (error: any) => {
            console.log('error =>', error);
            toast.error(error);
        });
    }

    const allowedMenuItem = (url: string) => {
        if (loggedinuser && loggedinuser.hasOwnProperty(`module`) && Array.isArray(loggedinuser.module) && loggedinuser.userTypeID && ![1].includes(loggedinuser.userTypeID)) {
            const permissions = loggedinuser.module.filter((o: any) => !o.isTemplate);
            const found_access = permissions.map((o: any) => o.url).find((o: any) => {
                //console.log("O is", permissions.map((o: any) => o.url), (childUrl + `===` + o));
                if (o.includes(`^`)) {
                    return url.startsWith(o.replace(`^`, ``))
                } else {
                    return (url === o)
                }
            });
            return found_access;
        }
        return true;
    }

    return (
        <div className={`left-panel bg-primary text-white flex-shrink-0 h-screen flex flex-col overflow-x-visible transition-[width] duration-300 ease-in-out ${collapse ? 'w-[4rem]' : 'w-[16.25rem]'}`}>
            <div className={`flex justify-between py-4 border-b-[.03rem] border-[#406A42] h-[3.75rem] bg-white transition-[padding] duration-300 ease-in-out ${collapse ? 'px-1.5' : 'px-3'} items-center`}>
                {/* {!collapse && <h2 className='uppercase'>CYCLOPS</h2>} */}
                <div className="relative flex items-center h-[3rem] overflow-hidden" style={{ width: collapse ? '2rem' : '10rem', transition: 'width 300ms ease-in-out' }}>
                    <img src={logoFull} alt="Cyclops" width={140} className={`absolute transition-opacity duration-200 ${collapse ? 'opacity-0 pointer-events-none' : 'opacity-100'}`} />
                    <img src={logoIcon} alt="Cyclops" width={32} className={`absolute transition-opacity duration-200 ${collapse ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} />
                </div>
                {/* <div className='flex justify-center gap-2'>
                    <a href="" className='flex w-[1.25rem] h-[1.25rem] rounded-full overflow-hidden bg-white relative'> <span className='w-[0.313rem] h-[0.313rem] bg-[#F46A6A] rounded-full absolute right-0'></span> <img src={noImg} alt="" /> </a>
                </div> */}
            </div>
            <div className="flex-grow flex flex-col justify-between">
                <ul className="font-normal">

                    {allowedMenuItem(URLS.MY_DASHBOARD) && <MenuLink to={URLS.MY_DASHBOARD} label='My Dashboard' icon={<Icon name='meter' size={1.25} />} collapse={collapse} />}
                    {allowedMenuItem(URLS.ADOPTION_DASHBOARD) && <MenuLink to={URLS.ADOPTION_DASHBOARD} label={<span className="flex items-center gap-1">Adoption Dashboard <span className="inline-flex items-center px-1.5 py-0.5 text-[9px] font-semibold rounded-full bg-[#22c55e] text-white leading-none">New</span></span>} icon={<LayoutDashboard size={20} className="text-white" />} collapse={collapse} />}
                    {allowedMenuItem(URLS.MANAGER_DASHBOARD) && <MenuLink to={URLS.MANAGER_DASHBOARD} label={<span className="flex items-center gap-1">Manager Dashboard <span className="inline-flex items-center px-1.5 py-0.5 text-[9px] font-semibold rounded-full bg-[#22c55e] text-white leading-none">New</span></span>} icon={<LayoutDashboard size={20} className="text-white" />} collapse={collapse} />}
                    <div className='my-[5px] h-0 w-full border-b border-[#406A42]'></div>

                    {allowedMenuItem(URLS.FACILITIES) && <MenuLink to={URLS.FACILITIES} label='Facilities' icon={<Icon name='location' size={1.25} />} collapse={collapse} />}
                    {allowedMenuItem(URLS.ASSETS) && <MenuLink to={URLS.ASSETS} label='Assets' icon={<Icon name='assets' size={1.25} />} collapse={collapse} />}
                    {allowedMenuItem(URLS.WIPASSETS) && <MenuLink to={URLS.WIPASSETS} label='WIP Assets' icon={<Icon name='wipassets' size={1.25} />} collapse={collapse} />}
                    {allowedMenuItem(URLS.WARRANTIES) && <MenuLink to={URLS.WARRANTIES} label='Warranties' icon={<Icon name='warranties' size={1.25} />} collapse={collapse} />}
                    {/* <MenuLink to={URLS.LEASE_ASSETS} label='Lease Assets' icon={<Icon name='lease' size={1.25} />} disabled={true}  collapse={collapse} /> */}
                    {allowedMenuItem(URLS.DEPRECIATION) && <MenuLink to={URLS.DEPRECIATION} label='Depreciation' icon={<Icon name='depreciation' size={1.10} />} collapse={collapse} />}
                    <div className='my-[5px] h-0 w-full border-b border-[#406A42]'></div>
                    {allowedMenuItem(URLS.MAINTENANCE_CALENDER) && <MenuLink to={URLS.MAINTENANCE_CALENDER} label='Preventive Maintenance' icon={<Icon name='calendar' size={1.25} />} collapse={collapse} />}
                    {allowedMenuItem(URLS.WORK_REQUEST) && <MenuLink to={URLS.WORK_REQUEST} label='Work Request' icon={<Icon name='workrequest' size={1.25} />} collapse={collapse} />}
                    {allowedMenuItem(URLS.WORK_ORDERS) && <MenuLink to={URLS.WORK_ORDERS} label='Tasks' icon={<Icon name='workorders' size={1.25} />} collapse={collapse} />}
                    {allowedMenuItem(URLS.CHECKLISTS) && <MenuLink to={URLS.CHECKLISTS} label='Checklists' icon={<Icon name='checklist' size={1.25} />} collapse={collapse} />}
                    <div className='my-[5px] h-0 w-full border-b border-[#406A42]'></div>
                    {
                        (
                            allowedMenuItem(URLS.INVENTORY.SPEAR_PARTS.LIST) ||
                            allowedMenuItem(URLS.INVENTORY.RECEIVE_STOCK) ||
                            allowedMenuItem(URLS.INVENTORY.STOCK_PICKING) ||
                            allowedMenuItem(URLS.INVENTORY.STOCK_ADJUSTMENT) ||
                            allowedMenuItem(URLS.INVENTORY.CYCLE_COUNT)
                        ) && (
                            <li
                                className="dropdown dropdown-bottom w-full"
                                onMouseEnter={e => {
                                    if (collapse) {
                                        const dropdown = e.currentTarget;
                                        const button = dropdown.querySelector('[role="button"]') as HTMLElement;
                                        if (button) button.focus();
                                    }
                                }}
                                onMouseLeave={e => {

                                    const dropdown = e.currentTarget;
                                    const button = dropdown.querySelector('[role="button"]') as HTMLElement;
                                    if (button) button.blur();

                                }}
                            >
                                <div tabIndex={0} role="button" className="w-full flex gap-2 items-center text-white h-[2.375rem] pl-[0.938rem] transition-all hover:bg-[#2020324D] group">
                                    <div className='flex justify-center items-center w-[1.675rem]'>
                                        <Icon name='inventory' size={1.25} />
                                    </div>
                                    {!collapse &&
                                        <div className='flex justify-between items-center w-full'>
                                            <span className="ml-0 transition-all group-hover:ml-1 text-[0.875rem]">Inventory</span>
                                            <Icon name='arrowdown' className='pr-3' size={1.25} />
                                        </div>
                                    }
                                </div>
                                <ul tabIndex={0} className="dropdown-content z-10 w-[14.6rem] bg-slate-800 rounded-sm z-1 mx-2 p-2 shadow-sm">
                                    {allowedMenuItem(URLS.INVENTORY.SPEAR_PARTS.LIST) && <MenuLink to={URLS.INVENTORY.SPEAR_PARTS.LIST} label='Spare Parts' icon={null} collapse={collapse} sub={true} />}
                                    {allowedMenuItem(URLS.INVENTORY.RECEIVE_STOCK) && <MenuLink to={URLS.INVENTORY.RECEIVE_STOCK} label='Receive Stock' icon={null} collapse={collapse} sub={true} />}
                                    {/*<MenuLink to={URLS.INVENTORY.STOCK_PICKING_OLD} label='Stock Picking' icon={null} collapse={collapse} sub={true}/>*/}
                                    {allowedMenuItem(URLS.INVENTORY.STOCK_PICKING) && <MenuLink to={URLS.INVENTORY.STOCK_PICKING} label='Stock Picking' icon={null} collapse={collapse} sub={true} />}
                                    {allowedMenuItem(URLS.INVENTORY.STOCK_ADJUSTMENT) && <MenuLink to={URLS.INVENTORY.STOCK_ADJUSTMENT} label='Stock Adjustment' icon={null} collapse={collapse} sub={true} />}
                                    {allowedMenuItem(URLS.INVENTORY.CYCLE_COUNT) && <MenuLink to={URLS.INVENTORY.CYCLE_COUNT} label='Cycle Count' icon={null} collapse={collapse} sub={true} />}
                                </ul>
                            </li>
                        )
                    }

                    {
                        (
                            allowedMenuItem(URLS.PURCHASING.REQUEST.LIST) ||
                            allowedMenuItem(URLS.PURCHASING.ORDER) ||
                            allowedMenuItem(URLS.INVENTORY.RECEIVE_STOCK)
                        ) && (
                            <li
                                className="dropdown dropdown-bottom w-full"
                                onMouseEnter={e => {
                                    if (collapse) {
                                        const dropdown = e.currentTarget;
                                        const button = dropdown.querySelector('[role="button"]') as HTMLElement;
                                        if (button) button.focus();
                                    }
                                }}
                                onMouseLeave={e => {

                                    const dropdown = e.currentTarget;
                                    const button = dropdown.querySelector('[role="button"]') as HTMLElement;
                                    if (button) button.blur();

                                }}
                            >
                                <div
                                    tabIndex={1}
                                    role="button"
                                    className="w-full flex gap-2 items-center text-white h-[2.375rem] pl-[0.938rem] transition-all hover:bg-[#2020324D] group"
                                >
                                    <div className='flex justify-center items-center w-[1.675rem]'>
                                        <Icon name='purchase' size={1.25} />
                                    </div>
                                    {!collapse &&
                                        <div className='flex justify-between items-center w-full'>
                                            <span className="ml-0 transition-all group-hover:ml-1 text-[0.875rem]">Purchasing</span>
                                            <Icon name='arrowdown' className='pr-3' size={1.25} />
                                        </div>
                                    }
                                </div>
                                <ul tabIndex={1} className="dropdown-content z-10 w-[14.6rem] bg-slate-800 rounded-sm z-1 mx-2 p-2 shadow-sm">
                                    {allowedMenuItem(URLS.PURCHASING.REQUEST.LIST) && <MenuLink to={URLS.PURCHASING.REQUEST.LIST} label='Purchase Request' icon={null} collapse={collapse} sub={true} />}
                                    {allowedMenuItem(URLS.PURCHASING.ORDER) && <MenuLink to={URLS.PURCHASING.ORDER} label='Purchase Order' icon={null} collapse={collapse} sub={true} />}
                                    {/*<MenuLink to={URLS.PURCHASING.STOCK} label='Purchase Stock' icon={null} disabled={true} collapse={collapse} sub={true}/> */}
                                    {allowedMenuItem(URLS.INVENTORY.RECEIVE_STOCK) && <MenuLink to={URLS.INVENTORY.RECEIVE_STOCK} label='Receive Stock' icon={null} collapse={collapse} sub={true} />}
                                </ul>
                            </li>
                        )
                    }

                    {allowedMenuItem(URLS.VENDORS) && <MenuLink to={URLS.VENDORS} label='Vendors' icon={<Icon name='vendors' size={1.25} />} collapse={collapse} />}

                </ul>
                <ul className="font-light">

                    {allowedMenuItem(URLS.USERS) && <MenuLink to={URLS.USERS} label='Users' icon={<Icon name='users' size={1.25} />} collapse={collapse} />}
                    {allowedMenuItem(URLS.REPORTS) && <MenuLink to={URLS.REPORTS} label='Reports' icon={<Icon name='reports' size={1.25} />} collapse={collapse} />}
                    {allowedMenuItem(URLS.SETTINGS) && <MenuLink to={URLS.SETTINGS} label='Settings' icon={<Icon name='settings' size={1.20} />} collapse={collapse} />}
                    {/* {allowedMenuItem(URLS.ACCOUNT) && <MenuLink to={URLS.ACCOUNT} label='Account' icon={<Icon name='allusers' size={1.25} />} disabled={true} collapse={collapse} />} */}
                    <li>
                        <span onClick={logout} className="flex gap-2 items-center text-white h-[2.375rem] pl-[0.938rem] transition-all hover:bg-[#2020324D] group" onMouseEnter={() => collapse && setShow(true)} onMouseLeave={() => collapse && setShow(false)}>
                            <div className='flex justify-center items-center w-[1.675rem]'>
                                <Icon name='logout' size={1.25} className='text-white' />
                            </div>
                            {!collapse && <span className="ml-0 transition-all group-hover:ml-1 text-[0.875rem]">Logout</span>}
                            {(collapse && show) && <div className={`absolute z-10 w-[14.6rem] bg-slate-800 rounded-sm z-1 mx-2 p-2 shadow-sm left-[40px]`}>Logout</div>}
                        </span>
                    </li>

                </ul>
            </div>

        </div>
    );
};

export default LeftPanel;